(() => {
  function setup(root = document) {
    root.querySelectorAll('.z-product-colours').forEach((nav) => {
      if (nav.dataset.previewReady) return;
      nav.dataset.previewReady = 'true';
      let active = null;
      const close = () => {
        if (!active) return;
        active.classList.remove('is-preview-open');
        active.querySelector('.z-product-colours__preview').style.transform = '';
        active = null;
      };
      const open = (option) => {
        close();
        active = option;
        option.classList.add('is-preview-open');
        const preview = option.querySelector('.z-product-colours__preview');
        const rect = preview.getBoundingClientRect();
        const edge = document.documentElement.clientWidth - 12;
        const offset = rect.left < 12 ? 12 - rect.left : Math.min(0, edge - rect.right);
        if (offset) preview.style.transform = `translateX(${offset}px)`;
      };
      nav.querySelectorAll('.z-product-colours__option').forEach((option) => {
        option.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch' && window.matchMedia('(hover: hover)').matches) open(option);
        });
        option.addEventListener('pointerleave', () => {
          if (active === option) close();
        });
        option.addEventListener('focusin', () => {
          if (option.matches(':focus-visible')) open(option);
        });
        option.addEventListener('focusout', () => {
          if (active === option) close();
        });
        option.addEventListener('pointerdown', close);
      });
      nav.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });
      window.addEventListener('resize', close);
    });
  }
  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
